<template>
  <div>
    <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="handleSearch()">
      <el-form-item label="完整的公司名称" prop="companyKey">
        <el-input
            v-model="dataForm.companyKey"
            placeholder="请输入完整公司名称"
            clearable
            size="small"
            style="width: 250px;"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleSearch()">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 显示历史记录提示 -->
    <div v-if="showHistoryTip" class="history-tip" style="margin-bottom: 20px;">
      <el-alert
          title="该供应商已在排查历史中存在，请选择操作"
          type="warning"
          :closable="false"
      >
        <div class="history-actions" style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px;">
          <span>发现 {{ historyRecords.length }} 条历史记录，最新创建于 {{ latestHistoryDate }}</span>
          <div class="button-group" style="display: flex; gap: 10px;">
            <el-button size="small" @click="viewHistory">查看历史</el-button>
            <el-button size="small" type="primary" @click="confirmRescan">重新查询</el-button>
            <el-button size="small" @click="adjustSearch">调整查询条件</el-button>
          </div>
        </div>
      </el-alert>
    </div>

    <!-- 历史记录表格 -->
    <div v-if="showHistoryTable" class="history-table">
      <el-table
          :data="historyRecords"
          stripe
          v-loading="dataListLoading"
          style="width: 100%;">
        <el-table-column
            prop="name"
            header-align="center"
            align="center"
            label="公司名称">
        </el-table-column>
        <el-table-column
            prop="companyId"
            header-align="center"
            align="center"
            label="公司ID">
        </el-table-column>
        <el-table-column
            prop="result"
            header-align="center"
            align="center"
            label="排查结果"
            width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.result == 0" style="color: green;">低风险</span>
            <span v-if="scope.row.result == 1" style="color: orange;">中风险</span>
            <span v-if="scope.row.result == 2" style="color: red;">高风险</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="createTime"
            header-align="center"
            align="center"
            label="创建时间"
            width="200">
        </el-table-column>
        <el-table-column
            fixed="right"
            header-align="center"
            align="center"
            width="200"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewDetails(scope.row)">
              查看详情
            </el-button>
            <el-button type="text" size="small" @click="viewInvestigationReport(scope.row)">
              准入排查报告
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 风险排查结果 -->
    <div v-if="showResult" class="result-section" style="margin-top: 20px;">
      <h3>风险排查结果</h3>
      <div class="risk-summary" style="background-color: #f5f7fa; padding: 15px; border-radius: 4px; margin-bottom: 20px;">
        <div class="summary-item" style="margin-bottom: 10px; display: flex;">
          <span class="label" style="font-weight: bold; min-width: 100px;">公司名称：</span>
          <span class="value" style="flex: 1;">{{ resultData.name }}</span>
        </div>
        <div class="summary-item" style="margin-bottom: 10px; display: flex;">
          <span class="label" style="font-weight: bold; min-width: 100px;">公司ID：</span>
          <span class="value" style="flex: 1;">{{ resultData.companyId }}</span>
        </div>
        <div class="summary-item" style="margin-bottom: 10px; display: flex;">
          <span class="label" style="font-weight: bold; min-width: 100px;">排查结果：</span>
          <span class="value" :class="'risk-' + resultData.result" style="flex: 1;" :style="{ color: getResultColor(resultData.result) }">{{ getResultText(resultData.result) }}</span>
        </div>
        <div class="summary-item" style="margin-bottom: 10px; display: flex;">
          <span class="label" style="font-weight: bold; min-width: 100px;">创建时间：</span>
          <span class="value" style="flex: 1;">{{ resultData.createDate }}</span>
        </div>
      </div>

      <!-- 维度命中情况 -->
      <div v-if="parsedOriginalHits && parsedOriginalHits.length > 0" class="dimension-section" style="margin-top: 20px;">
        <h4>维度命中情况</h4>
        <el-table :data="parsedOriginalHits" style="width: 100%;">
          <el-table-column prop="key" label="维度Key" width="150"></el-table-column>
          <el-table-column prop="name" label="维度名称"></el-table-column>
          <el-table-column prop="level" label="风险等级" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.level == 1" style="color: orange;">关注风险</span>
              <span v-if="scope.row.level == 2" style="color: red;">警示风险</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalHits" label="维度命中数" width="100"></el-table-column>
        </el-table>
      </div>

      <!-- 信用分 -->
      <div v-if="parsedCreditRateResult" class="credit-section" style="margin-top: 20px;">
        <h4>信用分</h4>
        <div class="credit-info">
          <p><strong>分数：</strong>{{ parsedCreditRateResult.Score }}</p>
          <p><strong>描述：</strong>{{ parsedCreditRateResult.ScoreDescInfo }}</p>
        </div>
      </div>

      <!-- 准入排查报告按钮 -->
      <div class="report-actions" style="margin-top: 20px;">
        <el-button type="primary" @click="viewInvestigationReport(resultData)">查看准入排查报告</el-button>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog title="排查详情" :visible.sync="detailDialogVisible" width="80%" append-to-body>
      <div v-if="selectedRecord">
        <h4>公司信息</h4>
        <p><strong>名称：</strong>{{ selectedRecord.name }}</p>
        <p><strong>ID：</strong>{{ selectedRecord.companyId }}</p>
        <p><strong>排查结果：</strong>
          <span :style="{ color: getResultColor(selectedRecord.result) }">{{ getResultText(selectedRecord.result) }}</span>
        </p>
        <p><strong>创建时间：</strong>{{ selectedRecord.createTime }}</p>

        <h4 v-if="parsedSelectedOriginalHits">维度命中情况</h4>
        <el-table v-if="parsedSelectedOriginalHits" :data="parsedSelectedOriginalHits" style="width: 100%; margin-bottom: 20px;">
          <el-table-column prop="key" label="维度Key" width="150"></el-table-column>
          <el-table-column prop="name" label="维度名称"></el-table-column>
          <el-table-column prop="level" label="风险等级" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.level == 1" style="color: orange;">关注风险</span>
              <span v-if="scope.row.level == 2" style="color: red;">警示风险</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalHits" label="维度命中数" width="100"></el-table-column>
        </el-table>

        <h4 v-if="parsedSelectedCreditRateResult">信用分</h4>
        <div v-if="parsedSelectedCreditRateResult" class="credit-info">
          <p><strong>分数：</strong>{{ parsedSelectedCreditRateResult.Score }}</p>
          <p><strong>描述：</strong>{{ parsedSelectedCreditRateResult.ScoreDescInfo }}</p>
        </div>
      </div>
    </el-dialog>

    <!-- 准入排查报告弹窗 -->
    <el-dialog title="准入排查报告" :visible.sync="reportDialogVisible" width="90%" append-to-body>
      <div style="height: 80vh;">
        <iframe id="reportIframe" ref="reportIframe" frameborder="0" style="width: 100%; height: 100%;" allowfullscreen></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { searchByCompanyKey, scanRisk, rescanRisk,getSign } from '@/controller/supplier';

export default {
  name: 'QccScanRisk',
  data() {
    return {
      dataForm: {
        companyKey: ''
      },
      sign: '',
      historyRecords: [],
      showHistoryTip: false,
      showHistoryTable: false,
      showResult: false,
      resultData: {},
      detailDialogVisible: false,
      selectedRecord: null,
      dataListLoading: false,
      reportDialogVisible: false,
      currentReportData: {}
    }
  },
  computed: {
    latestHistoryDate() {
      if (this.historyRecords.length > 0) {
        const latest = this.historyRecords[0];
        return latest.createTime || '未知';
      }
      return '无记录';
    },
    // 解析维度命中情况
    parsedOriginalHits() {
      if (this.resultData.originalHits) {
        try {
          return JSON.parse(this.resultData.originalHits);
        } catch (e) {
          console.error('解析维度命中情况失败:', e);
          return null;
        }
      }
      return null;
    },
    // 解析信用分
    parsedCreditRateResult() {
      if (this.resultData.creditRateResult) {
        try {
          return JSON.parse(this.resultData.creditRateResult);
        } catch (e) {
          console.error('解析信用分失败:', e);
          return null;
        }
      }
      return null;
    },
    // 解析选中记录的维度命中情况
    parsedSelectedOriginalHits() {
      if (this.selectedRecord && this.selectedRecord.originalHits) {
        try {
          return JSON.parse(this.selectedRecord.originalHits);
        } catch (e) {
          console.error('解析选中记录维度命中情况失败:', e);
          return null;
        }
      }
      return null;
    },
    // 解析选中记录的信用分
    parsedSelectedCreditRateResult() {
      if (this.selectedRecord && this.selectedRecord.creditRateResult) {
        try {
          return JSON.parse(this.selectedRecord.creditRateResult);
        } catch (e) {
          console.error('解析选中记录信用分失败:', e);
          return null;
        }
      }
      return null;
    }
  },
  methods: {
    /** 重置按钮操作 */
    resetQuery() {
      this.dataForm = {
        companyKey: ''
      };
      this.handleSearch();
    },

    async handleSearch() {
      if (!this.dataForm.companyKey.trim()) {
        this.$message.warning('请输入完整的公司名称');
        return;
      }

      this.dataListLoading = true;

      try {
        // 查询历史记录
        const response = await searchByCompanyKey({name: this.dataForm.companyKey});

        if (response && response.code === '00') {
          this.historyRecords = response.body || [];

          if (this.historyRecords.length > 0) {
            // 显示历史记录提示
            this.showHistoryTip = true;
            this.showHistoryTable = false;
            this.showResult = false;
          } else {
            // 没有历史记录，直接发起新查询
            await this.scanRisk();
          }
        } else {
          this.$message.error(response.msg || '查询失败');
        }
      } catch (error) {
        console.error('查询历史记录失败:', error);
        this.$message.error('查询历史记录失败');
      } finally {
        this.dataListLoading = false;
      }
    },

    async scanRisk() {
      try {
        const params = {
          companyKey: this.dataForm.companyKey
        };

        const response = await scanRisk(params);

        if (response && response.code === '00') {
          if (response.body && response.body.hasHistory) {
            // 有历史记录，显示提示
            this.historyRecords = response.body.historyRecords || [];
            this.showHistoryTip = true;
            this.showHistoryTable = false;
            this.showResult = false;
          } else {
            // 显示新的排查结果
            this.resultData = response.body;
            this.resultData.diligenceId = response.body.id;
            this.showHistoryTip = false;
            this.showHistoryTable = false;
            this.showResult = true;
          }
        } else {
          this.$message.error(response.msg || '风险排查失败');
        }
      } catch (error) {
        console.error('风险排查失败:', error);
        this.$message.error('风险排查失败');
      }
    },

    async rescanRisk() {
      try {
        const params = {
          companyKey: this.dataForm.companyKey
        };

        const response = await rescanRisk(params);

        if (response && response.code === '00') {
          // 显示新的排查结果
          this.resultData = response.body;
          this.resultData.diligenceId = response.body.id;
          this.showHistoryTip = false;
          this.showHistoryTable = false;
          this.showResult = true;
        } else {
          this.$message.error(response.msg || '重新风险排查失败');
        }
      } catch (error) {
        console.error('重新风险排查失败:', error);
        this.$message.error('重新风险排查失败');
      }
    },

    viewHistory() {
      this.showHistoryTable = true;
      this.showHistoryTip = false;
      this.showResult = false;
    },

    confirmRescan() {
      this.rescanRisk();
    },

    adjustSearch() {
      this.showHistoryTip = false;
      this.showHistoryTable = false;
      this.showResult = false;
    },

    viewDetails(record) {
      this.selectedRecord = record;
      this.detailDialogVisible = true;
    },

    getResultText(result) {
      switch (result) {
        case 0:
          return '低风险';
        case 1:
          return '中风险';
        case 2:
          return '高风险';
        default:
          return '未知';
      }
    },

    getResultColor(result) {
      switch (result) {
        case 0:
          return 'green';
        case 1:
          return 'orange';
        case 2:
          return 'red';
        default:
          return 'gray';
      }
    },

    // 查看准入排查报告
    viewInvestigationReport(record) {
      this.currentReportData = record;
      this.reportDialogVisible = true;

      // 等待弹窗渲染完成后再加载iframe内容
      this.$nextTick(() => {
        this.loadInvestigationReport();
      });
    },

    // 加载准入排查报告
    async loadInvestigationReport() {
      const response = await getSign({});
      let sign;
      let timestamp;
      if (response && response.code === '00') {
        sign = response.body.sign || [];
        timestamp = response.body.timestamp || [];
        console.log('获取签名成功:', response.body)
        console.log('获取时间戳成功:', response.body.timestamp)
      }else {
        this.$message.error(response.msg || '获取签名失败');
      }
        // 这些是示例配置参数，实际应用中需要从系统配置中获取
      const phone = '13863182271'; // 示例电话
      const accessKey = 'PHCiakFKnnbCtwiYxpArTK25hz3xJj8G'; // 示例访问密钥
      //const timestamp = Date.now().toString(); // 当前时间戳// 示例签名

      // 从当前记录获取必要参数
      const companyId = this.currentReportData.companyId;
      const diligenceId = this.currentReportData.diligenceId; // 使用接口返回的id作为diligenceId

      // 准入排查详情URL
      const redirectUrl = `https://kys.qcc.com/external/supplier/risk-investigation-history/${companyId}?from=record&diligenceId=${diligenceId}&hideAddTo=Y`;
      const fallbackUrl = 'https://kys.qcc.com/error/403';
      const host = 'https://kys.qcc.com';
      const url = `${host}/rover/account/loginRedirect?phone=${encodeURIComponent(phone)}&accessKey=${encodeURIComponent(accessKey)}&timestamp=${encodeURIComponent(timestamp)}&sign=${encodeURIComponent(sign)}&redirectUrl=${encodeURIComponent(redirectUrl)}&fallbackUrl=${encodeURIComponent(fallbackUrl)}`;

      const iframe = this.$refs.reportIframe;
      if (iframe) {
        iframe.src = url;
      }
    }
  }
}
</script>

<style scoped>
.qcc-scan-risk-container {
  padding: 20px;
}

.search-section {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.search-input {
  width: 400px;
}

.history-tip {
  margin-bottom: 20px;
}

.history-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.button-group {
  display: flex;
  gap: 10px;
}

.history-table {
  margin-bottom: 20px;
}

.result-section {
  margin-top: 20px;
}

.risk-summary {
  background-color: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.summary-item {
  margin-bottom: 10px;
  display: flex;
}

.summary-item .label {
  font-weight: bold;
  min-width: 100px;
}

.summary-item .value {
  flex: 1;
}

.risk-0 {
  color: green;
}

.risk-1 {
  color: orange;
}

.risk-2 {
  color: red;
}

.dimension-section,
.credit-section {
  margin-top: 20px;
}

.credit-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.credit-info .label {
  font-weight: bold;
  margin-right: 10px;
}

.report-actions {
  margin-top: 20px;
}
</style>
